import './styles/gov-incentives.scss';

import { Breadcrumb } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import { PageTitle } from '../components/Primitives';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import rightArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Arrow-Icon-Primary.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query {
        incentives: allProductsJson(
            filter: {
                category: { eq: "/Englander/CMS/Government incentives/" }
            }
        ) {
            nodes {
                category
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                documents {
                    en_CA
                    en_US
                    fr_CA
                    caption {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
                attributes {
                    available_country {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    url {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        cms: allProductsJson(
            filter: { code: { eq: "englander_incitatifs-gov" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function GovernmentIncentives({ data }) {
    const { currentLocale } = usePageLocalization();

    const { t } = useTranslation('pages');
    const incentives = data.incentives.nodes;
    const cms = data.cms.nodes[0];
    const pageTitle = cms.title[currentLocale];
    const pageDesc = cms.description[currentLocale];
    const current_country =
        currentLocale.split('_')[1] === 'CA' ? 'Canada' : 'United States';
    const activeIncentives = incentives.filter((incentive: any) => {
        const incentive_country =
            incentive?.attributes?.available_country?.values?.[0].en_CA;

        return current_country === incentive_country;
    });

    return (
        <Layout>
            <SEO
                title={cms.attributes.meta_title.values[0][currentLocale]}
                description={
                    cms.attributes.meta_description.values[0][currentLocale]
                }
            />
            <div className='container gov-incentives'>
                <Breadcrumb
                    className='gov-breadcrumb'
                    elements={[
                        { link: '/', name: t('layout:appliance.home') },
                        { link: '', name: pageTitle },
                    ]}
                />
                <PageTitle title={pageTitle} description={pageDesc} />
                <div className='incentives'>
                    <span className='programs-offered'>
                        {activeIncentives.length === 0
                            ? t('incentives.no-incentives')
                            : t('incentives.programs-offered')}
                    </span>
                    <ul className='incentives-list'>
                        {activeIncentives.map((incentive: any) => {
                            const url =
                                incentive?.attributes?.url?.values?.[0]?.[
                                    currentLocale
                                ];
                            const fileUrl =
                                '/file/' +
                                incentive?.documents?.[0]?.[currentLocale];

                            return (
                                <li className='incentive' key={incentive.code}>
                                    <a
                                        href={url ? url : fileUrl}
                                        target='_blank'
                                        rel='noreferrer'
                                        title={incentive?.title[currentLocale]}
                                    >
                                        {incentive?.title[currentLocale]}
                                        <img src={rightArrowIcon} alt='' />
                                    </a>
                                </li>
                            );
                        })}

                        {activeIncentives.length === 0 && (
                            <span className='no-incentives'></span>
                        )}
                    </ul>
                </div>
            </div>
            <div className='gov-incentives-background' />
        </Layout>
    );
}
